import { render, staticRenderFns } from "./ClientRegistryEdit.vue?vue&type=template&id=07cbe48d&"
import script from "./ClientRegistryEdit.vue?vue&type=script&lang=js&"
export * from "./ClientRegistryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports